import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useState } from "react";
import { useAuth } from "authContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import hr from "date-fns/locale/hr";

interface AppointmentModalProps {
  show: boolean;
  onHide: () => void;
  appointment: any;
  deleteAppointment: (id: string) => void;
  editAppointment: (
    id: string,
    start: string,
    end: string,
    meet_url: string,
  ) => void;
}

const AppointmentModal: React.FC<AppointmentModalProps> = ({
  show,
  onHide,
  appointment,
  deleteAppointment,
  editAppointment,
}) => {
  const { userProfile } = useAuth();
  const [start, setStart] = useState(appointment.start);
  const [end, setEnd] = useState(appointment.end);
  const [meet_url, setMeetUrl] = useState(appointment.extendedProps.meet_url);

  const handleSubmit = () => {
    editAppointment(appointment.id, start, end, meet_url);
    onHide();
  };

  if (!appointment) {
    return null;
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Termin - {appointment.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {userProfile?.role === "PRINCIPAL" ||
        userProfile?.role === "TEACHER" ? (
          <Form>
            <Row className="mb-3">
              <Col md={4} className="align-self-center">
                <Form.Label>Početak</Form.Label>
              </Col>
              <Col md={8}>
                <DatePicker
                  selected={new Date(start)}
                  onChange={(date: Date | null) =>
                    setStart(date?.toISOString() || "")
                  }
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="Vrijeme"
                  dateFormat="dd.MM.yyyy HH:mm"
                  locale={hr}
                  showIcon
                  placeholderText="Odaberi početak termina"
                  className="form-control"
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={4} className="align-self-center">
                <Form.Label>Kraj</Form.Label>{" "}
              </Col>
              <Col md={8}>
                <DatePicker
                  selected={new Date(end)}
                  onChange={(date: Date | null) =>
                    setEnd(date?.toISOString() || "")
                  }
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="Vrijeme"
                  dateFormat="dd.MM.yyyy HH:mm"
                  locale={hr}
                  showIcon
                  placeholderText="Odaberi kraj termina"
                  className="form-control"
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={4} className="align-self-center">
                <Form.Label>Meeting URL</Form.Label>
              </Col>
              <Col md={8}>
                <Form.Control
                  type="url"
                  value={meet_url}
                  onChange={(e) => setMeetUrl(e.target.value)}
                />
              </Col>
            </Row>
          </Form>
        ) : (
          <>
            <p>
              <strong>Početak:</strong>{" "}
              {new Date(appointment.start).toLocaleString("hr-HR")}
            </p>
            <p>
              <strong>Kraj:</strong>{" "}
              {new Date(appointment.end).toLocaleString("hr-HR")}
            </p>
            <p>
              <strong>Meeting URL:</strong>{" "}
              <a
                href={appointment.extendedProps.meet_url}
                target="_blank"
                rel="noreferrer"
              >
                {appointment.extendedProps.meet_url}
              </a>
            </p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        {userProfile?.role === "PRINCIPAL" ||
        userProfile?.role === "TEACHER" ? (
          <>
            <Button
              variant="primary"
              onClick={() => deleteAppointment(appointment.id)}
            >
              Izbriši
            </Button>
            <div>
              <Button variant="primary" onClick={handleSubmit}>
                Spremi termin
              </Button>
              <Button
                variant="outline-primary"
                onClick={onHide}
                className="ms-2"
              >
                Zatvori
              </Button>
            </div>
          </>
        ) : (
          <Button variant="outline-primary" onClick={onHide}>
            Zatvori
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default AppointmentModal;
